(function (angular) {
  "use strict";

  /**
   * Controller for the admin footer settings page
   */
  function adminCustomSettingsController(
    siteSettingsPayload,
    SettingsApi,
    alerts,
  ) {
    var vm = this;

    // properties
    vm.settings = angular.copy(siteSettingsPayload);
    vm.loadingConfig = {
      show: false,
      message: "Saving...",
      progress: 0,
    };

    // methods
    vm.saveSettings = saveSettings;

    /**
     * Saves settings back to the API
     *
     * @returns {void}
     */
    function saveSettings() {
      vm.loadingConfig.show = true;

      var handleSaveSettingsSuccess = function (response) {
        // replace new settings
        vm.settings = angular.copy(response.data);
        // stop loader
        vm.loadingConfig.show = false;
        // show alert
        alerts.emit({
          theme: "success",
          title: "Saved",
          messages: ["Custom settings"],
        });
      };
      var handleSaveSettingsError = function () {
        // stop loader
        vm.loadingConfig.show = false;
        // show alert
        alerts.emit({
          theme: "error",
          title: "Error saving",
          messages: ["Please try again"],
        });
      };

      SettingsApi.save(
        {
          settings: vm.settings,
        },
        handleSaveSettingsSuccess,
        handleSaveSettingsError,
      );
    }
  }
  adminCustomSettingsController.$inject = [
    "siteSettingsPayload",
    "SettingsApi",
    "alerts",
  ];

  angular
    .module("app")
    .controller("adminCustomSettingsController", adminCustomSettingsController);
})(angular);
